import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { RouteService } from 'src/app/core/services/route.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  public searchText: any = "";
  public isRouteChange: boolean = false;
  public searchSource = new BehaviorSubject('');
  public searchEvent = this.searchSource.asObservable();
  /**
   * Special property to hide search
   * Note: This will get unset once route is changed
   */
  public disabled: boolean = false;
  public filterdisabled: boolean = false;

  constructor(private route: RouteService) {
    this.cleaner();
  }

  /**
   * Call on input search change
   * @param string value to search
   */
  onInputChange(search: string,isRouteChange: boolean = false) {
    this.searchText = search;
    this.isRouteChange = isRouteChange;
    this.searchSource.next(search);
  }

  /**
   * Cleanup search text on route change
   */
  cleaner = () => {
    this.route.change().subscribe(() => {
      this.disabled = false;
      this.filterdisabled = false;
      this.onInputChange("",true);
    });
  }

  /**
   * Filter input entered
   * @returns true if "searchText" passes filter
   */
  filter = (text: string) => {
    if (!this.searchText) return true;
    const regex = new RegExp(
      this.searchText?.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
      'i'
    );
    return regex.test(text?.trim());
  };
}
